export interface CsvColumn<T> {
  key: string;
  label: string;
  value: (row: T) => string | number | null | undefined;
}

export type CsvCell = string | number | null | undefined;

function escapeCell(value: CsvCell): string {
  const str = value === null || value === undefined ? "" : String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function triggerDownload(filename: string, rows: CsvCell[][]): void {
  const content = `\uFEFF${rows.map((row) => row.map((cell) => escapeCell(cell)).join(",")).join("\r\n")}`;
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function downloadCsv<T>(filename: string, columns: CsvColumn<T>[], rows: T[]): void {
  const header = columns.map((column) => escapeCell(column.label));
  const body = rows.map((row) => columns.map((column) => escapeCell(column.value(row))));
  triggerDownload(filename, [header, ...body]);
}

// 多段导出：一个文件内包含多个带标题的分段表格（如「负责人工作量」+「负责人风险分布」），
// 段与段之间用空行隔开，方便主管做周报时逐段引用。
export function downloadCsvMatrix(filename: string, rows: CsvCell[][]): void {
  triggerDownload(filename, rows);
}